import store from '@/store';

export default (name) => (to, from, next) => {
  if (store.getters['auth/isRole'](name)) {
    next();
  } else {
    next({ name: 'home' });
  }
};
